import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '@sharedModule/directives/control-value-accessor.directive';
import { InputData } from '@sharedModule/models/input-data.model';

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrl: './input-file.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFileComponent),
      multi: true,
    },
  ],
})
export class InputFileComponent<T> extends ControlValueAccessorDirective<T> {
  @Input() inputData?: InputData;
  @Output() chooseDocument = new EventEmitter<string>();

  onChooseDocument(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (): void => {
        this.chooseDocument.emit(reader.result as string);
      };
    }
  }
}
